<ng-container *ngFor="let item of data;let i = index; trackBy:trackByFn">
    <div class="container">
        <div class="context" (mousedown)="mousedown($event, i)" (mouseup)="mouseup(i)" (mouseover)="mouseover(i)"
            (mouseout)="mouseout(i)" [class.mouseover]="mouseoveringIndex === i">
            <ng-container *ngTemplateOutlet="bar;context:{dataItem: item, index: i}">
            </ng-container>
        </div>
    </div>
</ng-container>